import axios from 'axios'

const path = 'audit'

export default {
  async listLogs(q, pageRequest) {
    const resp = await axios.get(`${path}/logs`, {
      params: {
        ...q,
        ...pageRequest
      }
    })
    return resp.data
  },

  async getLogger() {
    const resp = await axios.get(`${path}/logger`)
    return resp.data
  },

  async updateLogger(loggerUpdate) {
    await axios.put(`${path}/logger`, loggerUpdate)
  },

  async signLogs() {
    await axios.put(`${path}/sign`)
  },

  async verifyLogs() {
    const resp = await axios.get(`${path}/verify`)
    return resp.data
  },

  async exportAuditLogFile(q) {
    const resp = await axios.get(`${path}/export`, {
      params: {
        ...q
      },
      responseType: 'blob'
    })
    return resp.data
  }
}
